/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorTextTitle from 'base/components/labrador/TextTitle';

export const DynamicLabradorTextTitle: typeof LabradorTextTitle = (props) => {
    return <ErrorBoundary><LabradorTextTitle {...props} /></ErrorBoundary>;
}
export type DynamicLabradorTextTitleProps = PropsFromComponent<typeof LabradorTextTitle>;
